/**
 * @deprecated This type is deprecated. Use BuildTypeEnum instead.
 */
export default {
  default: 'default',
  canteen: 'canteen',
  pantry: 'pantry',
  social: 'social',
  market: 'market',
  companykitchen: 'companykitchen',
  refive: 'refive',
};
